export const navbarMedia = {
    m_width: "1256px",
    m_display: "none"
}
export const navbarMediaCenter = {
    m_width: "1156px",
    m_display: "none"
}